import React from "react";

export default function TransferMember() {
  return (
    <div className="card">
      <h3>Transfer Member</h3>
      <p>Transfer functionality goes here.</p>
    </div>
  );
}
